module.exports = __webpack_public_path__ + "img/hr-straight-rail-vertical-metals-remnants.854c353e.png";